export const DEFAULT_ATTRS: Attrs = {
	postTypes: [ 'page', 'post' ],
	isWooCommerceEnabled: true,
	includeWooCommerceOrderInfo: true,
};

export type Attrs = {
	readonly postTypes: ReadonlyArray< string >;
	readonly isWooCommerceEnabled: boolean;
	readonly includeWooCommerceOrderInfo: boolean;
};

export type SetAttrs = ( attrs: Partial< Attrs > ) => void;
